module.exports = __webpack_public_path__ + "static/media/LoyalityProgramsCards2.4301d2a7.png";